import { Pipe, PipeTransform, inject } from '@angular/core';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Cmg1003BorrowerQuery } from '../../loan-state';
@Pipe({ name: 'toBorrowerName$' })
export class ToBorrowerNamePipe implements PipeTransform {
  private readonly _borrowerQuery = inject(Cmg1003BorrowerQuery);

  transform(value: number): any {
    return this._borrowerQuery.selectEntity(value).pipe(
      switchMap((borrowerModel) => {
        return of(`${borrowerModel?.firstName} ${borrowerModel?.lastName}`);
      }),
    );
  }
}
